import { z } from 'zod';

import { zodPaginatedResponseSchema } from '@vestigas/data';

export const zodInvoiceTimelineQueryParamsSchema = z.object({
  limit: z.number().int().min(1).max(500),
});

/**
 * `eventType` stays an open string because the backend can add event names
 * independently of this client.
 */
const zodInvoiceTimelineActorUserSchema = z.object({
  firstName: z.string().nullish(),
  id: z.uuid(),
  lastName: z.string().nullish(),
});

export const zodInvoiceTimelineEventSchema = z.object({
  actor: z.enum(['system', 'user']),
  actorUser: zodInvoiceTimelineActorUserSchema.nullish(),
  actorUserId: z.uuid().nullish(),
  comment: z.string().nullish(),
  createdOn: z.iso.datetime({ offset: true }),
  eventType: z.string(),
  id: z.uuid(),
  sequence: z.number().int(),
});

export const zodInvoiceTimelineResponseSchema = zodPaginatedResponseSchema(
  zodInvoiceTimelineEventSchema,
);
